module.exports = __webpack_public_path__ + "img/in_progress_pickup.28ef20e3.svg";